<div class="py-8">
  <div class="card-responsive card-horizontal mx-auto">
    <div class="card-body flex flex-col items-center justify-center gap-4">
      <mat-spinner diameter="40"></mat-spinner>
      <div class="headline-x-small text-decoration-dark text-center" [innerText]="'SignUp.ActivatingYourAccount' | translate"></div>
    </div>
  </div>
</div>
